import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import styles from "./Settings.module.scss";
import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import PageHeader from "components/PageHeader/PageHeader";
import Container from "components/Container/Container";
import Row from "components/Row/Row";
import FormElement from "components/FormElement/FormElement";

import SelectAlt from "components/SelectAlt/SelectAlt";

import HR from "components/HR/HR";
import Button from "components/Button/Button";
import { states, statesObj, country_list, countriesObj, toggleDropdowns } from "helpers/utils";
import ProfilePhoto from "components/ProfilePhoto/ProfilePhoto";
import { useHistory } from "react-router-dom";

import { submitUserSettingsFormAction, loadUserSettingsFormAction } from "store/actions/Actions";

const Settings = (props) => {
  const {
    loadUserSettingsFormAction,
    submitUserSettingsFormAction,
    SettingsReducer,
  } = props;

  // Keep track of officer role state
  const [officerState, setOfficerState] = useState({
    active: "t",
    privacy: false,
    security: false,
    status: "active",
    firstname: "",
    lastname: "",
    email: "",
    address_1: "",
    address_2: "",
    city: "",
    state: "",
    state_name: "",
    postcode: "",
    password: "",
    "confirm-password": "",
    phone: "",
    "profile-photo": "",
    "profile-photo-filename": "Add/Upload New",
    // showHints: true
  });

  useEffect(() => {
    const state_name = statesObj[officerState.state] || officerState.state;
    if (state_name) {
      setOfficerState((s) => ({
        ...s,
        state_name,
      }));  
    }
  }, [officerState.state]);

  const [stateErrors, setStateErrors] = useState({});

  const history = useHistory();

  useEffect(() => {
      if (!SettingsReducer.user) {
        loadUserSettingsFormAction();
      } else {
        let profileInitImg = '';
        if (process.env.REACT_APP_BASE_API_URL && SettingsReducer.user.image) {
          profileInitImg = `${process.env.REACT_APP_BASE_API_URL}${SettingsReducer.user.image}` || '';
        }
        setOfficerState({ ...SettingsReducer.user, "profile-photo": profileInitImg });
      }
  }, [SettingsReducer.user, loadUserSettingsFormAction]);

  const handleChange = (inputName) => (e) => {
      e.persist();
      setOfficerState((s) => ({
          ...s,
          [inputName]: e.target.value,
      }));
      setStateErrors((s) => ({ ...s, [inputName]: '' }));
  };

  const handleSelectAlt = (inputName) => (e) => {
      e.persist();
      setOfficerState((s) => ({
          ...s,
          [inputName]: e.target.dataset.name,
          [e.target.dataset.attr]: e.target.dataset.id,
      }));
      setStateErrors((s) => ({ ...s, [inputName]: '' }));
  };
  
  const handleSubmitEditForm = (e) => {
    e.preventDefault();
    if (
      officerState.password === "" ||
        officerState.password !== officerState['confirm-password'] ||
        officerState.firstname === "" ||
        officerState.lastname === "" ||
        officerState.email === "" ||
        officerState.phone === "" ||
        officerState.address_1 === "" ||
        officerState.city === "" ||
        // officerState.state === "" ||
        officerState.postcode === ""
    ) {
        setStateErrors({
            ...stateErrors,
            name: officerState.name === "" ? "Name is required" : "",
            password: officerState.password === "" ? "Password is required" : "",
            "confirm-password": officerState.password !== officerState['confirm-password'] ? "Password doesn't match" : "",
            contact_first: officerState.contact_first === "" ? "First name is required" : "",
            contact_last: officerState.contact_last === "" ? "Last name is required" : "",
            email: officerState.email === "" ? "Email is required" : "",
            phone: officerState.phone === "" ? "Phone is required" : "",
            address_1: officerState.address_1 === "" ? "Address is required" : "",
            city: officerState.city === "" ? "City is required" : "",
            state: officerState.state === "" ? "State is required" : "",
            postcode: officerState.postcode === "" ? "Postal code is required" : "",
        });
    } else {
      submitUserSettingsFormAction({
        ...officerState,
      });
    }
  }
  const stateDropdownRef = React.createRef();
  const countryDropdownRef = React.createRef();

  const filteredStates = officerState.state_name ? 
    states.filter(s => s.name && s.name.toLowerCase().includes(officerState.state_name && officerState.state_name.toLowerCase()))
    :
    states;

  return (
    <AppLayoutWrapFull 
      onClick={toggleDropdowns([
        stateDropdownRef,
        countryDropdownRef,
      ])}
    >
      <PageHeader loadStats={false} />
      <Container>
        <form className={styles["add-user-form"]}>
          <div className={styles.holder}>
            <div className={styles.left}>
              <FormElement
                className={styles.form_element}
                labelText="FIRST NAME" 
                htmlFor="firstname"
                errorMessage={stateErrors.firstname}
              >
                <input
                  name="firstname"
                  type="text"
                  placeholder="Enter your first name"
                  value={officerState.firstname}
                  onChange={handleChange("firstname")}
                />
              </FormElement>

              <FormElement
                className={styles.form_element}
                labelText="LAST NAME" 
                htmlFor="lastname"
                errorMessage={stateErrors.lastname}
              >
                <input
                  name="lastname"
                  type="text"
                  placeholder="Enter your last name"
                  value={officerState.lastname}
                  onChange={handleChange("lastname")}
                />
              </FormElement>

              <FormElement
                className={styles.form_element}
                labelText="EMAIL"
                htmlFor="email"
                errorMessage={stateErrors.email}
              >
                <input
                  autoComplete="new-password"
                  name="email"
                  type="email"
                  placeholder="Enter your email address"
                  value={officerState.email}
                  onChange={handleChange("email")}
                />
              </FormElement>


              <FormElement
                className={styles.form_element}
                labelText="ADDRESS"
                htmlFor="address_1"
                errorMessage={stateErrors.address_1}
              >
                <input
                  name="address_1"
                  type="text"
                  placeholder="Street and number"
                  // placeholder="Enter your address"
                  value={officerState.address_1}
                  onChange={handleChange("address_1")}
                />
              </FormElement>

              <FormElement
                className={styles.form_element}
                // labelText="ADDRESS 2"
                htmlFor="address_2"
                errorMessage={stateErrors.address_2}
              >
                <input
                  name="address_2"
                  type="text"
                  placeholder="Apartment, building, floor (optional)"
                  value={officerState.address_2}
                  onChange={handleChange("address_2")}
                />
              </FormElement>

              <FormElement
                    className={styles.form_element}
                    labelText="COUNTRY"
                    htmlFor="country_name"
                    errorMessage={stateErrors.country_name}
                >
                    <SelectAlt
                        placeholder="Country"
                        dropdownToggleRef={countryDropdownRef}
                        value={officerState.country_name}
                        onClick={handleSelectAlt("country_name")}
                        labels={countriesObj}
                    >
                    {country_list.map((item) => <li key={item.id} data-attr="country_code" data-id={item.id} data-name={item.name} value={item.name}>{item.name}</li>)}
                    </SelectAlt>
              </FormElement>

              <Row className={`${styles["form-group-row"]} ${styles["city-state-postcode"]} ${styles.form_element}`}>
                <FormElement
                  labelText="CITY"
                  htmlFor="city"
                  errorMessage={stateErrors.city}
                >
                  <input
                    name="city"
                    type="text"
                    placeholder="City"
                    value={officerState.city}
                    onChange={handleChange("city")}
                  />
                </FormElement>

                <FormElement
                  labelText="STATE / REGION"
                  htmlFor="state"
                  errorMessage={stateErrors.state}
                >
                  <SelectAlt
                    placeholder="State"
                    dropdownToggleRef={stateDropdownRef}
                    value={officerState.state_name}
                    onClick={handleSelectAlt("state_name")}
                    setState={setOfficerState}
                    labels={statesObj}
                  >
                    {filteredStates.map(item => <li key={item.abbrev} data-attr="state" data-id={item.abbrev} data-name={item.name} value={item.name}>{item.name}</li>)}
                  </SelectAlt>
                </FormElement>

                <FormElement
                  labelText="POSTAL CODE"
                  htmlFor="postcode"
                  errorMessage={stateErrors.postcode}
                >
                  <input
                    name="postcode"
                    type="text"
                    placeholder="Postal Code"
                    value={officerState.postcode}
                    onChange={handleChange("postcode")}
                  />
                </FormElement>
              </Row>


            </div>

            <div className={styles.right}>
              <Row className={`${styles["form-group-row"]} ${styles.form_element}`}>
                <FormElement
                  labelText="PASSWORD"
                  htmlFor="password"
                  errorMessage={stateErrors.password}
                >
                  <input
                    autoComplete="new-password"
                    name="password"
                    type="password"
                    placeholder="Enter your password"
                    defaultValue={officerState.password}
                    onChange={handleChange("password")}
                  />
                </FormElement>

                <FormElement
                  labelText="CONFIRM PASSWORD"
                  htmlFor="confirm-password"
                  errorMessage={stateErrors["confirm-password"]}
                >
                  <input
                    name="confirm-password"
                    type="password"
                    placeholder="Confirm your password"
                    defaultValue={officerState["confirm-password"]}
                    onChange={handleChange("confirm-password")}
                  />
                </FormElement>
              </Row>

              <FormElement
                className={styles.form_element}
                noLabel={true}
                errorMessage={stateErrors["phone"]}
              >
                <label htmlFor="phone">CONTACT PHONE</label>
                <Row className={styles["form-group-row"]}>
                  <input
                    className={styles["contact-phone-input"]}
                    name="phone"
                    type="tel"
                    value={officerState["phone"]}
                    onChange={handleChange("phone")}
                  />
                </Row>
              </FormElement>

              <ProfilePhoto state={officerState} setState={setOfficerState} />

            </div>

          </div>

          <HR className={styles.hr} />

          <div className={styles["submit-box"]}>
            <Button text="Cancel" color="secondary" onClick={() => history.push('/')} />
            <Button 
              icon="far fa-save" 
              text="Save"
              onClick={handleSubmitEditForm}
            />
          </div>

        </form>

      </Container>
    </AppLayoutWrapFull>
  );
};

const mapStateToProps = ({
    SettingsReducer
  }) => {
  return {
    SettingsReducer
  }
}

const mapDispatchToProps = {
  loadUserSettingsFormAction,
  submitUserSettingsFormAction,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Settings);
